import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import NotificationBell from '../NotificationBell';
import {
  LayoutDashboard, Users, Music, FileText, CreditCard, HelpCircle, DollarSign,
  Settings, Palette, FileCheck, History, Youtube, Trash2, Link2,
  ArrowLeft, Menu, X, Shield
, Tag } from 'lucide-react';

const adminNav = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/users', icon: Users, label: 'Utenti' },
  { to: '/admin/releases', icon: Music, label: 'Release' },
  { to: '/admin/artists', icon: Users, label: 'Artisti' },
  { to: '/admin/labels', icon: Tag, label: 'Label' },
  { to: '/admin/statements', icon: FileText, label: 'Rendiconti' },
  { to: '/admin/payments', icon: CreditCard, label: 'Pagamenti' },
  { to: '/admin/finance', icon: DollarSign, label: 'Guadagni' },
  { to: '/admin/youtube-adsense', icon: Youtube, label: 'YouTube AdSense' },
  { to: '/admin/support', icon: HelpCircle, label: 'Supporto' },
  { to: '/admin/oac', icon: Youtube, label: 'OAC YouTube' },
  { to: '/admin/takedowns', icon: Trash2, label: 'Take Down' },
  { to: '/admin/settings', icon: Settings, label: 'Impostazioni' },
  { to: '/admin/theme', icon: Palette, label: 'Tema' },
  { to: '/admin/legal', icon: FileCheck, label: 'Pagine Legali' },
  { to: '/admin/logs', icon: History, label: 'Log Azioni' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:static inset-y-0 left-0 z-50 w-64 bg-gray-950 text-white transition-transform duration-200 flex flex-col`}>
        <div className="p-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <Shield size={20} className="text-yellow-400" />
            <div>
              <h1 className="font-bold text-lg">ADMIN PANEL</h1>
              <p className="text-xs text-gray-500">ProudNoize</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto py-3 px-2">
          {adminNav.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg mb-0.5 text-sm transition
                ${isActive ? 'bg-yellow-500/20 text-yellow-400 font-medium' : 'text-gray-400 hover:bg-white/5 hover:text-white'}`}>
              <item.icon size={16} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button onClick={() => navigate('/dashboard')}
            className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-gray-400 hover:bg-white/10 hover:text-white transition">
            <ArrowLeft size={16} />Torna alla Workstation
          </button>
        </div>
      </aside>

      {/* Overlay mobile */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-h-screen">
        <header className="bg-gray-950/80 backdrop-blur border-b border-white/10 px-4 lg:px-8 py-3 flex items-center justify-between sticky top-0 z-30">
          <div className="flex items-center gap-3">
            <button className="lg:hidden p-2 text-white" onClick={() => setSidebarOpen(true)}><Menu size={20} /></button>
            <span className="text-sm text-gray-400">Admin: {user?.first_name} {user?.last_name}</span>
          </div>
          <div className="flex items-center gap-3">
            <NotificationBell />
            <NavLink to="/dashboard" className="text-xs text-yellow-400 hover:underline flex items-center gap-1"><ArrowLeft size={12} />Workstation</NavLink>
          </div>
        </header>
        <main className="p-4 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
